import {
  Box,
  Divider,
  FormControl,
  Grid,
  MenuItem,
  Radio,
  Select,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import ActionHeader from "../../../../UI/action-header/action-header";
import GlobalCard from "../../../../UI/card/GlobalCard";
import "../location.scss";
import "../../../../scss/common.scss";
import {
  cityName,
  countryName,
  timeZoneName,
  calendarName,
} from "../../../../mock-data/location-mock-data";
import upload from "../../../../assets/common-imgs/upload.png";

const AddLocation = () => {
  const [selectedValue, setSelectedValue] = React.useState("");
  const [initial, setInitial] = useState({
    city: "",
    country: "",
    timeZone: "",
    calendar: "",
  });
  const handleChange = (event: any) => {
    setInitial({ ...initial, [event.target.name]: event.target.value });
  };

  const handleChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div className="addLocation">
      <Box>
        <ActionHeader heading="Location Form" />
      </Box>
      <GlobalCard>
        <Grid container>
          <Grid item md={3} sm={12}>
            <h4 className="heading4 h4 fw-600">Location Details</h4>
          </Grid>
          <Grid item md={4.5} sm={12} xs={12}>
            <Box display="flex" flexDirection="column">
              <label className="fw-500">Location Name</label>
              <input
                className="input br-5"
                type="text"
                placeholder="Enter name"
              />
            </Box>
            <Box display="flex" flexDirection="column">
              <label className="fw-500">Address</label>
              <input
                className="input br-5"
                type="text"
                placeholder="Enter address"
              />
            </Box>
            <Box display="flex" flexDirection="column">
              <FormControl>
                <label className="fw-500">City</label>
                <Select
                  className="select-input"
                  value={initial.city}
                  onChange={handleChange}
                  name="city"
                  sx={{ height: "48px" }}
                >
                  {cityName.map((item: any, i: number) => {
                    return (
                      <MenuItem key={i} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" flexDirection="column">
              <FormControl>
                <label className="fw-500">Country</label>
                <Select
                  className="select-input"
                  value={initial.country}
                  onChange={handleChange}
                  name="country"
                  sx={{ height: "48px" }}
                >
                  {countryName.map((item: any, i: number) => {
                    return (
                      <MenuItem key={i} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" flexDirection="column">
              <FormControl>
                <label className="fw-500">TimeZone</label>
                <Select
                  className="select-input"
                  value={initial.timeZone}
                  onChange={handleChange}
                  name="timeZone"
                  sx={{ height: "48px" }}
                >
                  {timeZoneName.map((item: any, i: number) => {
                    return (
                      <MenuItem key={i} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" flexDirection="column">
              <FormControl>
                <label className="fw-500">Calendar</label>
                <Select
                  className="select-input"
                  value={initial.calendar}
                  onChange={handleChange}
                  name="calendar"
                  sx={{ height: "48px" }}
                >
                  {calendarName.map((item: any, i: number) => {
                    return (
                      <MenuItem key={i} value={item}>
                        {item}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" flexDirection="column">
              <label className="fw-500">Upload Image</label>
              <Box display='flex' flexDirection='column' alignItems='center' sx={{ border: '2px dashed #E5E5E5',borderRadius:'5px', height:'300px' }}>
              <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center' sx={{width:'300px', height:'100%', position:'relative'}}>
              <TextField type="file" sx={{width:'200px'}} />
              <img src={upload} alt='upload' style={{width:'100px', height:'72px', position:'absolute', top:'50px'}} />
              <h5 className="h5 fw-600 h5Color">Drag and drop file here</h5>
              <h5 className="h5 fw-600 h5Color">or</h5>
              <h5 className="h5 fw-600 h5Primary">Choose from computer</h5>
              </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ border: "1px solid #CCCCCC", marginTop: "40px" }} />
        <Grid container>
          <Grid item md={3} sm={12}>
            <h4 className="heading4 h4 fw-600">Applies to</h4>
          </Grid>
          <Grid item md={4.5} sm={12} display="flex">
            <Box className="radioCheck" display="flex" alignItems="center">
              <Radio
                className="radio"
                value="a"
                name="radio-button"
                checked={selectedValue === "a"}
                onChange={handleChangeRadio}
              />
              <p className="fs-16 fw-500 lh-24">All employees</p>
            </Box>
            <Box className="radioCheck" display="flex" alignItems="center">
              <Radio
                className="radio"
                value="b"
                name="radio-button"
                checked={selectedValue === "b"}
                onChange={handleChangeRadio}
              />
              <p className="fs-16 fw-500 lh-24">Select employees</p>
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          className="btns"
          display="flex"
          justifyContent="flex-end"
        >
          <Grid item>
            <Box>
              <button className="cancel btn btn-light-grey">Cancel</button>
              <button className="cancel save btn btn-secondary">Save</button>
            </Box>
          </Grid>
        </Grid>
      </GlobalCard>
    </div>
  );
};

export default AddLocation;
